export default __webpack_public_path__ + "static/media/tn.878a7338.svg";